// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"single-sign-on_wrapper__57Q_o"};